const carouselTransform = (carouselData) => {
  return carouselData?.map(
    ({
      color: { code: colorCode, name: colorName, swatchUrl, slug } = {},
      modelInfo: { description, modelIsWearing } = {},
      imageInfo,
      inseam,
      // mediaInfo, // note:: not available on legacy?
    }) => ({
      "model-info": {
        modelIsWearing,
        description,
      },
      "image-info": imageInfo,
      inseam,
      "swatch-image": colorName,
      "color-code": colorCode,
      "swatch-color-name": colorName,
    })
  );
};

export default carouselTransform;
